export default [
	'Agent',
	// 'Seller',
	// "Buyer",
	"Investor",
	"Lender",
	"Team",
	"Tenant",
	"Vendor"
];